import { render, staticRenderFns, recyclableRender, components } from "./mp-share.vue?vue&type=template&id=c5408620&"
var renderjs
import script from "./mp-share.vue?vue&type=script&lang=js&"
export * from "./mp-share.vue?vue&type=script&lang=js&"
import style0 from "./mp-share.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/mp-share.vue"
export default component.exports